export const CARD_WIDTH = 160;
export const CARD_HEIGHT = 224;
export const COLUMN_GAP = 40;
export const ROW_GAP = 60;
